export const REGISTER_BOOT_SKELETON_ID = 'register-boot-skeleton'
export const REGISTER_SKELETON_STILL_LOADING_MS = 5000

type RegisterSkeletonWindow = Window & { __registerSkeletonShownAt?: number }

const getRegisterSkeletonWindow = () => window as RegisterSkeletonWindow

export const markRegisterSkeletonShown = (now = Date.now()) => {
  const registerWindow = getRegisterSkeletonWindow()
  if (registerWindow.__registerSkeletonShownAt == null) {
    registerWindow.__registerSkeletonShownAt = now
  }
}

export const getRegisterSkeletonStillLoadingDelayMs = (now = Date.now()) => {
  const shownAt = getRegisterSkeletonWindow().__registerSkeletonShownAt
  if (typeof shownAt !== 'number') return REGISTER_SKELETON_STILL_LOADING_MS
  return Math.max(0, REGISTER_SKELETON_STILL_LOADING_MS - (now - shownAt))
}

/** Matches `/register/:id`, `/register/:id/:enrollmentId`, and `/:slug/register/:activitySlug`. */
export const isRegisterPagePath = (urlOrPath: string): boolean => {
  const path = urlOrPath.split(/[?#]/, 1)[0] ?? ''
  return /(?:^|\/)register(?:\/|$)/.test(path)
}

export const hideRegisterBootSkeleton = () => {
  document.getElementById(REGISTER_BOOT_SKELETON_ID)?.setAttribute('hidden', '')
}
